<template>
    <div class="flash_box">

    </div>
</template>

<script>
import request from '@/http/request'
export default {
  data () {
    return {

    }
  },

  mounted () {
    request('api/books/getTodayTrends', { params: { search_words: '今日' } })
      .then((result) => {
        this.todayTrendsList = result
      })
  }
}

</script>
